import React from "react";

function Icon({ fillHover }) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='31'
			height='37'
			fill='none'
			id='svgRes'
			viewBox='0 0 31 37'>
			<path
				fill='#010101'
				className={`${fillHover}`}
				d='M25.81 35.405c-2 1.94-4.185 1.633-6.288.715-2.225-.94-4.267-.98-6.615 0-2.94 1.265-4.492.898-6.247-.715-9.964-10.27-8.494-25.909 2.817-26.48 2.756.143 4.676 1.51 6.288 1.633 2.41-.49 4.717-1.899 7.29-1.715 3.082.245 5.41 1.47 6.94 3.675-6.37 3.818-4.858 12.21.98 14.557-1.163 3.063-2.674 6.105-5.185 8.35l.02-.02zM15.562 8.802c-.306-4.553 3.39-8.31 7.636-8.677.592 5.268-4.777 9.188-7.636 8.677z'></path>
		</svg>
	);
}

export default Icon;
